import { useState } from 'react';

import { useNavigate } from 'react-router';

import { AttachFile } from '@mui/icons-material';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { IconButton, Tooltip } from '@mui/material';
import { GridRowModel } from '@mui/x-data-grid-pro';

import { RevendedorFilesModal } from 'pages/revendedor/revendedor/components';

type RevendedorActionColumn = {
    row: GridRowModel;
};

export function RevendedorActionColumn({ row }: RevendedorActionColumn) {
    const navigate = useNavigate();
    const [openFilesModal, setOpenFilesModal] = useState(false);

    return (
        <>
            <RevendedorFilesModal files={row.arquivo} open={openFilesModal} setOpen={setOpenFilesModal} />

            <Tooltip title="Editar">
                <IconButton sx={{ p: 0.5 }} onClick={() => navigate(`/revendedor/form/${row.id}`)}>
                    <ModeEditOutlineOutlinedIcon />
                </IconButton>
            </Tooltip>

            <Tooltip title="Anexos">
                <span>
                    <IconButton sx={{ p: 0.5 }} onClick={() => setOpenFilesModal(true)} disabled={!row.arquivo.length}>
                        <AttachFile />
                    </IconButton>
                </span>
            </Tooltip>
        </>
    );
}
